import EditFilledIcon from '../Icon/EditFilledIcon.js';

//
const DRAG_THRESHOLD = 5;
var script = {
  name: 'InlineEditViewContent',
  components: {
    EditFilledIcon
  },

  data() {
    return {
      startX: 0,
      startY: 0
    };
  },

  methods: {
    onMouseDown(e) {
      this.startX = e.clientX;
      this.startY = e.clientY;
    },

    onEnter() {
      this.$emit('edit-requested');
    },

    onClick(e) {
      if (this.mouseHasMoved(e)) return;
      this.$emit('edit-requested');
    },

    mouseHasMoved({
      clientX,
      clientY
    }) {
      return Math.abs(this.startX - clientX) >= DRAG_THRESHOLD || Math.abs(this.startY - clientY) >= DRAG_THRESHOLD;
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Form/InlineEditViewContent.vue_rollup-plugin-vue=script.js